<fn-modal-header class="modal-header">
  <h5 class="modal-title" mat-dialog-title>About Graph Details</h5>
  <button
    type="button"
    class="close"
    data-dismiss="modal"
    aria-label="Close"
    (click)="close()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</fn-modal-header>
<mat-dialog-content>
  <h6 class="blue">* Details Tab</h6>
  <ul>
    <li>
      Displays the <strong>total alert count</strong> for each unique alert type
      on a given day.
    </li>
    <li>
      Sums <strong>all occurrences</strong> of that alert type during the
      day—even if they are resolved and reappear.
    </li>
  </ul>
  <div class="alert alert-primary">
    <strong>Example:</strong> If an alert of type <strong>X</strong> appears
    with a count of 10, is resolved, and reappears with a count of 5, the
    Details tab will show <strong>15</strong> for type <strong>X</strong> on
    that day.
  </div>
  <h6 class="text-success">* Unique Count Tab</h6>
  <ul>
    <li>
      Shows the number of <strong>distinct appearances</strong> of each alert
      type on a given day.
    </li>
    <li>
      Each new appearance (even of the same type) is counted once,
      <strong>regardless of its alert count</strong>.
    </li>
  </ul>
  <div class="alert alert-success">
    <strong>Example:</strong> If an alert of type <strong>X</strong> appears, is
    resolved, and then appears again, the Unique Count tab will show
    <strong>2</strong> for type <strong>X</strong>, even if the counts were 10
    and 5.
  </div>
</mat-dialog-content>
